import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import classNames from 'clsx';
import { GalleryController } from './GalleryController';
import { GalleryCounter } from './GalleryCounter';
import { GalleryImageSlide } from './GalleryImageSlide';
import { GalleryIndicator } from './GalleryIndicator';
import { GalleryLabels } from './GalleryLabels';
import { GallerySliders } from './GallerySliders';
import { GalleryTitle } from './GalleryTitle';
import { GalleryVideoSlide } from './GalleryVideoSlide';
import { GalleryContainer, GalleryIndicators } from './styles/gallery.styled';
/**
 * The gallery component can be used to display images inside an image carousel
 */
export const Gallery = ({ variant = 'grey_round', reference, slides, labels, class: className, onChangeSlideHandler, initialSlideIndex = 0, }) => {
    const [activeSlide, setActiveSlide] = useState(initialSlideIndex < slides.length ? initialSlideIndex : 0);
    const galleryClassnames = classNames('PONCHO-gallery', className, {
        'PONCHO-gallery--blue-square': variant === 'blue_square',
    });
    const handleChange = (index) => {
        if (onChangeSlideHandler) {
            onChangeSlideHandler(index, activeSlide < index ? 'next' : 'previous');
        }
        setActiveSlide(index);
    };
    return (_jsxs(GalleryContainer, { className: galleryClassnames, id: reference, role: "tablist", tabIndex: 0, "$variant": variant, onKeyDown: ({ key }) => {
            if (key === 'ArrowLeft' || key === 'ArrowRight') {
                let slide = activeSlide + (key === 'ArrowLeft' ? -1 : 1);
                slide = Math.max(0, slide);
                slide = Math.min(slides.length - 1, slide);
                handleChange(slide);
            }
        }, children: [slides.map((slide, index) => {
                const active = activeSlide === index;
                return (_jsxs(Fragment, { children: [_jsx(GalleryController, { index: index, reference: reference, active: active, handleChange: handleChange }), slide.type === 'video' ? (_jsx(GalleryVideoSlide, { index: index, reference: reference, videoId: slide.videoId, active: active })) : (_jsx(GalleryImageSlide, { index: index, reference: reference, slide: slide, active: active })), active && (_jsx(GallerySliders, { index: index, reference: reference, active: active, slideCount: slides.length })), slide.caption ? _jsx(GalleryTitle, { caption: slide.caption }) : _jsx("span", {})] }, index));
            }), labels && _jsx(GalleryLabels, { labels: labels }), variant === 'grey_round' && (_jsx(GalleryIndicators, { className: "PONCHO-gallery__indicators", children: slides.map((_, index) => (_jsx(GalleryIndicator, { index: index, active: index === activeSlide, reference: reference }, index))) })), variant === 'blue_square' && (_jsx(GalleryCounter, { class: "PONCHO-gallery__counter", index: activeSlide, total: slides.length }))] }));
};
